/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Quick item popup component. The component displays the Quick item popup details.
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 08/12/2020 
 */
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
/**
 * Ref: QI_PC_05
 * Importing the action and store file and set to an object.
 */
import * as QuickItemAction from '../actions/QuickItemAction';
import QuickItemStore from '../stores/QuickItemStore';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import swal from 'sweetalert';
import { withTranslation, Trans } from 'react-i18next'
class QuickItemComponent extends Component {
    _isMounted = false;
    /**
    * Ref: QI_PC_07
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */
    constructor(props) {
        super(props);
        this.assignQuickItemData = this.assignQuickItemData.bind(this);
        this.submitQuickItem = this.submitQuickItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitQuickItemResponse = this.submitQuickItemResponse.bind(this);
        /**
        * Ref: QI_PC_08
        * Set the initial values of the state variables
        */
        this.state = {
            lblItemID: "",
            lblItemdescr: "",
            lblitemmfg: "",
            lblitemmfgid: "",
            lblUOM: "",
            txtQOH: "",
            trPrice: "",
            lblItemCurrencyCodeVisible: "",
            lblItemCurrencySymbolVisible: "",
            lblItemCurrencyCode: "",
            lblItemCurrencySymbol: "",
            decPrice: "",
            txtQty: "",
            isLoaded: false,
            qtyValidationMsg: "",
            EquipmentDelete: this.props.EquipmentDelete //BugID-5804 -Vishwa S
        }

    }
    /**
    * Ref: QI_PC_09
    * componentDidMount method will be first method which will be invoked
    * when Quick item entry popup is loaded
    */
    componentDidMount() {
        this._isMounted = true;
        console.log("componentDidMount", this.props);
        if (this.props.cpitemid != "0") {
            let getQuickItemBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                itemid: this.props.itemid,
                cpitemid: this.props.cpitemid,
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_ShowPrice: CookieService.getLocalStorageValues("Session_ShowPrice"),
                CLIENT_MFG_PART: (this.props.Itemdetails != undefined ? this.props.Itemdetails.CLIENT_MFG_PART : ""),/*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
                MANUFACTURER: (this.props.Itemdetails != undefined ? this.props.Itemdetails.MANUFACTURER : ""),
                SUPPLIER_ID: (this.props.Itemdetails != undefined ? this.props.Itemdetails.SUPPLIER_ID : ""),
                Fav_Catagory: (this.props.Itemdetails != undefined ? this.props.Itemdetails.Fav_Catagory : ""),
                ITEMDESCRIPTION: (this.props.Itemdetails != undefined ? this.props.Itemdetails.ITEMDESCRIPTION : ""),
                IsFav: this.props.IsFav
            };
            /**
            * Ref: QI_PC_11
            * Invoke the action to get the page load data from API.
            */
            QuickItemAction.getQuickItemDetails(getQuickItemBO);
        }
        /**
        * Ref: QI_PC_10
        * Define the listener methods
        */
        QuickItemStore.on("quickItemData", this.assignQuickItemData);
        QuickItemStore.on("submitQuickItem", this.submitQuickItemResponse);
        //QuickItemStore.on("ShopCartsubmitQuickItem", this.ShopCartsubmitQuickItemResponse);
    }
    /**
    * Ref: QI_PC_14
    * Listener method for submit response
    */
    submitQuickItemResponse = () => {
        let quickItemSubmitRes = JSON.parse(QuickItemStore.submitQuickItem);
        console.log("quickItemSubmitRes", quickItemSubmitRes);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.props.closePopup(1);
    }
    //ShopCartsubmitQuickItemResponse = () => {
    //    let quickItemSubmitRes = JSON.parse(QuickItemStore.ShopCartsubmitQuickItem);
    //    console.log("quickItemSubmitRes", quickItemSubmitRes);
    //    this.props.closePopup(quickItemSubmitRes);
    //}
    /**
    * Ref: QI_PC_12
    * Submit button click funtion of quick item popup
    */
    submitQuickItem = () => {
        //[9/19/22, Bug - 2663 - To pass the state value of item id for the quick item entry and check catalog submit, Dhevanesm R]
        let OrderNonCatalogItemL = [];
        let ItemDetails = {
            ItemId: this.state.lblItemID,
            filePath: "",
        }
        OrderNonCatalogItemL.push(ItemDetails)
        let QuickBO = {
            NonItemDetails: OrderNonCatalogItemL
        }
        //[9/19/22, Bug - 2663 - To pass the state value of item id for the quick item entry and check catalog submit, Dhevanesm R]
        let submitQuickItemBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            txtItemID: this.state.lblItemID,
            intCpitemid: 0,//this.props.cpitemid,
            lblQuickqty: this.state.txtQty,
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: CookieService.getLocalStorageValues("Session_ImageLocPath"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //BugID-5804 -Vishwa S
            EquipmentDelete: this.state.EquipmentDelete, //BugID-5804 -Vishwa S
            DueDate: "",/*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
            File_Path: ""
        };
        OrderNonCatalogItemL.push(ItemDetails)
        if (this.state.txtQty) {
            if (!this.state.quickItemResponse.QuickItem[0].form.includes('DOORS')) {
                this.setState({ qtyValidationMsg: "" });
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                QuickItemAction.submitQuickItem(submitQuickItemBO);
            } else {

                if (CookieService.getLocalStorageValues("Doorlist") != undefined) {
                    if ((CookieService.getLocalStorageValues("Doorlist").indexOf(this.props.itemid) == -1)) {
                        $('#quickconfirm').modal('hide');
                        this.props.history.push({
                            pathname: "/DoorForm",
                            state: { item: QuickBO, CartBO: submitQuickItemBO, qty: this.state.txtQty, pagename: 'QuickItem', searchKey: '', form: "DoorForm" }
                        });
                    } else {
                        $('#quickconfirm').modal('hide');
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "This Door Item is already added in the cart !"
                        });
                        //  alert("This Door Item is already added in the cart !")
                        return
                    }
                } else {
                    $('#quickconfirm').modal('hide');
                    this.props.history.push({
                        pathname: "/DoorForm",
                        state: { item: QuickBO, CartBO: submitQuickItemBO, qty: this.state.txtQty, pagename: 'QuickItem', searchKey: '', form: "DoorForm" }
                    });
                }

                //$('#quickconfirm').modal('hide');
                //this.props.history.push({
                //    pathname: "/DoorForm",
                //    state: { item: QuickBO, CartBO: submitQuickItemBO, qty: this.state.txtQty, pagename: 'QuickItem', searchKey: '', form: "DoorForm" }
                //});
            }

        } else {
            this.setState({ qtyValidationMsg: "Please enter quantity" });
        }
    }
    /**
     * Handle change method for quantity
     * @param e
     */
    handleChange = (e) => {
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                this.setState({ txtQty: e.target.value, qtyValidationMsg: "" });
            }
        }
    };
    /**
     * Ref: QI_PC_13
     * Handle change method for quantity
     */
    assignQuickItemData = () => {
        let quickItemResponse = JSON.parse(QuickItemStore.quickItemData);
        console.log("quickItemData", quickItemResponse);
        
        if (quickItemResponse.QuickItem.length > 0) {
            let quickItemData = quickItemResponse.QuickItem[0];
            if (this._isMounted) {
                this.setState(quickItemData);
                this.setState({ isLoaded: true });

            }

        } else {
            this.props.closePopup(2);
        }
        this.setState({ quickItemResponse: quickItemResponse });
        //[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    };
    componentWillUnmount() {
        QuickItemStore.removeListener("quickItemData", this.assignQuickItemData);
        QuickItemStore.removeListener("submitQuickItem", this.submitQuickItemResponse);
        this._isMounted = false;
    };

    render() {
        let disabledClass = this.state.isLoaded == false ? `custombtn-disabled` : ``;
        return (

            <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" data-backdrop="static" data-keyboard="false">
                <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header">
                        <h4 className="modal-title mt-1"><Trans>Quick Confirm</Trans></h4>
                        <button type="button" className="btn close-btn" onClick={() => this.props.closePopup("")}>
                            X
              </button>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                <span className="float-left info-label"><Trans>Quick Item Entry</Trans></span>
                                {/*<span className="float-right cc-help-info ">{CookieService.getLocalStorageValues("Session_CONAME")}</span>*/}
                            </div>
                        </div>
                        <div className="row justify-content-center my-5">
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>Item ID</Trans></label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.lblItemID}</label>
                                </div>
                            </div>
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>ItemKey</Trans><span> </span><Trans>Description</Trans></label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.lblItemdescr}</label>
                                </div>
                            </div>
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>Manufacturer</Trans></label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.lblitemmfg}</label>
                                </div>
                            </div>
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>Manufacturer</Trans><span> </span><Trans>part number</Trans></label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.lblitemmfgid}</label>
                                </div>
                            </div>
                            {/*{this.state.trPrice.toLowerCase()==`true`?<div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left">Price</label>
                                    <label className="info-value col-md-6 p-0 float-left">
                                        {this.state.lblItemCurrencySymbolVisible != "" && this.state.lblItemCurrencySymbolVisible != null && this.state.lblItemCurrencySymbolVisible.toLowerCase() == `true`?this.state.lblItemCurrencySymbol + ` `:``}
                                        {this.state.decPrice}
                                        {this.state.lblItemCurrencyCodeVisible != "" && this.state.lblItemCurrencyCodeVisible != null && this.state.lblItemCurrencyCodeVisible.toLowerCase() == `true` ? this.state.lblItemCurrencyCode : ``}
                                    </label>
                                </div>
                            </div>:null}*/}
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left">UOM</label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.lblUOM}</label>
                                </div>
                            </div>
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>Quantity On Hand</Trans></label>
                                    <label className="info-value col-md-6 p-0 float-left">{this.state.txtQOH}</label>
                                </div>
                            </div>
                            <div className="col-md-8 mb-2">
                                <div className="col-md-12 float-left">
                                    <label className="info-label col-md-6 p-0 float-left"><Trans>Quantity</Trans></label>
                                    <input type="text" className="form-control col-md-6 p-0 float-left popup-mobile-width" value={this.state.txtQty} maxLength="8" onChange={this.handleChange} />
                                    <span className="col-md-6 p-0 float-right err-msg text-danger">{this.state.qtyValidationMsg}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 text-center mb-2">
                            <button className={`btn btn-primary custom-btn-primary primary-btn px-4 ${disabledClass}`} onClick={this.submitQuickItem}><Trans>Submit</Trans></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(QuickItemComponent);
